import { ReoIcon, ReoSelect } from '@/deps/basic';
import type { CSSProperties } from 'react';
import React, { useEffect, useState } from 'react';
import './index.less';
import type { INavSelectProps } from './IComponent';
import classNames from 'classnames';

const NavSelect: React.FC<INavSelectProps> = (props) => {

    const list = React.useMemo(() => props.list.map(item => ({
        value: item.id,
        label: item.name,
        disabled: item.disabled,
        key: item.id,
    })), [props.list]);

    const [value, setValue] = useState(props.value);

    // 部分组件把这个组件当成是非受控使用，所以内部做一层受控拦截
    // 并且实现一个伪默认选中
    useEffect(() => { setValue(props.value); }, [props.value]);

    const onChange = React.useCallback((val: string) => {
        setValue(val);
        props.onChange(val);
    }, [props]);

    const selectStyles = React.useMemo<CSSProperties>(() => {
        return {
            '--input-bg-color': props.backgroundColor ?? '#EEEEEE',
        } as CSSProperties;
    }, [props.backgroundColor]);

    return (
        <div className={ 'nav_select_container' }>
            <div
                style={ selectStyles }
                className={ classNames('_nav_select_wrap', props.className) }
            >
                <ReoSelect
                    inputIcon={ (
                        <ReoIcon
                            name='icon-icon_down-2'
                            width={ 12 }
                        />
                    ) }
                    id={ props.id }
                    size='large'
                    value={ value }
                    dropdownClassName={ 'nav_drop' }
                    className={ 'nav_select' }
                    options={ list }
                    placeholder={ props.placeholder ?? 'All Products' }
                    // eslint-disable-next-line react/jsx-handler-names
                    onChange={ onChange }
                    showSearch={ props.isSearchable ?? false }
                    dropdownAlign={{
                        offset: [0, 0],
                        overflow: {
                            adjustY: false
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default NavSelect;
